module.exports = __webpack_public_path__ + "img/sleeve_ruffle_length.99bf96d0.png";